import './ErrorScreen.css';

function ErrorScreen({ title, message }) {
  return (
    <div className="error-screen">
      <div className="error-screen__content">
        <h1>{title}</h1>
        <p>{message}</p>
      </div>
    </div>
  );
}

export default ErrorScreen;
